import React, { useEffect, useRef, useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Loader } from '../../framework/forms/helpercomponents/Loader';
import { useTranslation } from '../../locale/useTranslation';
import { getter, process } from '@progress/kendo-data-query';
import * as API from '../../framework/API/api';
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, TOAST_TYPES } from '../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { DateCell, DateOnlyCell, DateTimeCell, LocalDateTimeColumn } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { ConfirmAlert } from '../../ConfirmAlert';
import { ArrayCell } from '../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { utility } from '../../framework/utility/utilityProvider';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import RefreshButton from '../../framework/forms/helpercomponents/buttons/RefreshButton';
import PreferenceRoundButton from '../../framework/forms/helpercomponents/buttons/PreferenceRoundButton';
import { UserPreference } from '../../modules/userPreference/UserPreference';
import BossDialog from '../../components/BossDialog';
import { ContextMenu } from 'primereact/contextmenu';
import ToastNotification from '../../components/ToastNotification';
import * as XLSX from 'xlsx';
import moment from 'moment';
import MetaInsightsForm from './MetaInsightsForm';
import PromotionPostHistoryPopup from './PromotionPostHistoryPopup';
import { CAMPAIGN_STATUS, POST_STATUS, PROMOTIONS_PLATFORM } from './SocialMediaConstant';
import { EnumCell } from '../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { ImageCell } from '../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { HrefCell } from '../../framework/forms/helpercomponents/CustomGridCells/HrefCell';
import { LookupCell } from '../../framework/forms/helpercomponents/CustomGridCells/LookupCell';
import { MyToggleButton } from '../../framework/forms/helpercomponents/CustomGridCells/MyToggleButton';
import { MenuCommandCell } from '../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import MyStatusCell from '../../components/MyStatusCell';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "uniqueId";
const idGetter = getter(DATA_ITEM_KEY);

const waveStyles = `
@keyframes flowingGradientWave {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}
@keyframes waveBounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-4px); }
}
`;

const SMPromotionScheduleCollection = (props) => {

    const { page_take = 50 } = props;

    const lang = useTranslation();
    const menuRef = useRef(null);

    const defaultPlatform = { _id: null, Description: "All" };
    const defaultAgency = { _id: null, Name: "All" };
    const defaultClient = { _id: null, Name: "All" };
    const defaultCampaignStatus = { _id: null, Description: "All" };
    const defaultAttachedPostStatus = { _id: null, Description: "All" };

    const [mediaData, setMediaData] = useState([]);
    const [filterdMediaData, setFilterdMediaData] = useState([]);
    const [sort, setSort] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [platforms, setPlatforms] = useState([defaultPlatform]);
    const [agencies, setAgencies] = useState([defaultAgency]);
    const [clients, setClients] = useState([defaultClient]);
    const [campaignStatus, setCampaignStatus] = useState([defaultCampaignStatus]);
    const [postStatus, setPostStatus] = useState([defaultAttachedPostStatus]);
    const [actionLoading, setActionLoading] = useState({ index: null, id: null, action: "" });

    const MyDateCell = (props) => <DateOnlyCell {...props} />;
    const MyArrayCell = (props) => <ArrayCell {...props} />;
    const MyHrefCell = (props) => <HrefCell {...props} />;
    const MyDatalookupCell = (props) => (<LookupCell {...props} dataColumns={dataColumns} />);
    const MyCustomToggleButton = (props) => (<MyToggleButton {...props} entityName={props.entityname} size={"small"} />);

    const defaultFilters = {
        platform: defaultPlatform,
        agency: defaultAgency,
        client: defaultClient,
        campaignStatus: defaultCampaignStatus,
        postStatus: defaultAttachedPostStatus,
        fromDate: "",
        toDate: ""
    };

    const [filters, _setFilters] = useState(defaultFilters);
    const setFilters = (data) => {
        _setFilters(data);
    };

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [dataColumns, setDataColumns] = useState([]);
    const [showInsightPopup, setShowInsightPopup] = useState({ show: false, item: null });
    const [showHistoryPopup, setShowHistoryPopup] = useState({ show: false, item: null });
    const [showPreferences, setShowPreferences] = useState(false);

    const [page, _setPage] = useState({ skip: 0, take: page_take });
    const pageRef = useRef({ skip: 0, take: page_take });
    const setPage = (data) => {
        pageRef.current = data;
        _setPage(data);
    };
    const [total, setTotal] = useState(0);

    const [dropdownFilters, setDropdownFilters] = useState({});

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadData({
            page: 1,
            per_page: page_take,
            platform: filters.platform,
            agency: filters.agency,
            client: filters.client,
            campaignStatus: filters.campaignStatus,
            postStatus: filters.postStatus,
            searchText,
            fromDate: filters.fromDate ? new Date(filters.fromDate).getTime() : null,
            toDate: filters.toDate ? new Date(new Date(filters.toDate).setUTCHours(23, 59, 59, 999)).getTime() : null
        });
    }, []);

    const loadCombo = async () => {
        const platformList = Object.keys(PROMOTIONS_PLATFORM).map((key) => ({
            _id: PROMOTIONS_PLATFORM[key],
            Description: key
        }));
        platformList.unshift({ _id: null, Description: "All" })
        setPlatforms(platformList);
        const agencyRes = await API.getDataLookup(ENTITYNAME.Agency, { sort: { Name: 1 } });
        agencyRes?.data?.unshift({ _id: null, Name: "All" })
        setAgencies(agencyRes.data);
        const clientRes = await API.getDataLookup(ENTITYNAME.Client, { sort: { Name: 1 } });
        clientRes?.data?.unshift({ _id: null, Name: "All" })
        setClients(clientRes.data);
        const campaignStatusRes = Object.keys(CAMPAIGN_STATUS).map((key) => ({
            _id: CAMPAIGN_STATUS[key],
            Description: key
        }));
        campaignStatusRes.unshift({ _id: null, Description: "All" })
        setCampaignStatus(campaignStatusRes);
        const postStatusRes = Object.keys(POST_STATUS).map((key) => ({
            _id: POST_STATUS[key],
            Description: key
        }));
        postStatusRes.unshift({ _id: null, Description: "All" })
        setPostStatus(postStatusRes);
    };


    const loadData = async (payload = {}) => {
        if (!payload.isSilentRefresh) {
            setIsLoading(true);
        }

        try {
            const currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            const columns = await API.getFormData("sm_promotion_schedule", currentUserId);
            if (columns && columns.length > 0) {
                setDataColumns(columns);
            }
            const response = await API.getPromotionPostFromCampaign(payload);

            if (response && response.success) {
                const dataWithUniqueId = (response.data || []).map((item, idx) => ({
                    ...item,
                    uniqueId: `${item._id}_${item.AttachedPost?._id || item.AttachedPost?.Post?._id || idx}`
                }));
                setMediaData(dataWithUniqueId);
                setFilterdMediaData(dataWithUniqueId);
                setTotal(response.pagination?.total || 0);
            } else {
                setMediaData([]);
                setFilterdMediaData([]);
                setTotal(0);
            }
        } catch (err) {
            console.error("Error loading promotion schedule collection:", err);
            setMediaData([]);
            setFilterdMediaData([]);
            setTotal(0);
        } finally {
            if (!payload.isSilentRefresh) {
                setIsLoading(false);
            }
        }
    };

    const applyFilters = (text, filterObj, loadFirstPage = false, isSilentRefresh = false) => {
        if (loadFirstPage) setPage({ skip: 0, take: page_take });

        let {
            platform = defaultPlatform,
            agency = defaultAgency,
            client = defaultClient,
            campaignStatus = defaultCampaignStatus,
            postStatus = defaultAttachedPostStatus,
            fromDate = null,
            toDate = null
        } = filterObj;

        let fromTime = fromDate ? new Date(fromDate).getTime() : null;
        let toTime = toDate ? new Date(new Date(toDate).setUTCHours(23, 59, 59, 999)).getTime() : null;

        loadData({
            page: loadFirstPage ? 1 : pageRef.current.skip / pageRef.current.take + 1,
            per_page: pageRef.current.take,
            platform,
            agency,
            client,
            campaignStatus,
            postStatus,
            searchText: text,
            fromDate: fromTime,
            toDate: toTime,
            isSilentRefresh
        });
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        let tmpFilter = { ...filters, [name]: value };
        setFilters(tmpFilter);
        setSelectedItems([]);
        setSelectedState({});
        setSort([]);
        applyFilters(searchText, tmpFilter, true);
    };

    const onDateFilterChange = (e) => {
        const { name, value } = e.target;
        const tmpFilter = { ...filters, [name]: value };

        if (name === "fromDate" && tmpFilter.toDate && value && value > tmpFilter.toDate) {
            tmpFilter.toDate = value;
        }
        if (name === "toDate" && tmpFilter.fromDate && value && value < tmpFilter.fromDate) {
            tmpFilter.fromDate = value;
        }

        setFilters(tmpFilter);
        setSelectedItems([]);
        setSelectedState({});
        setSort([]);
        applyFilters(searchText, tmpFilter, true);
    };

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim().toLowerCase();
        setSearchText(text);
    };

    useEffect(() => {
        if (searchText == null) return;
        const timeOut = setTimeout(() => {
            setIsLoading(true);
            applyFilters(searchText, filters, true);
        }, 600);
        return () => clearTimeout(timeOut);
    }, [searchText]);

    const onSelectionChange = (event) => {
        const selectedId = idGetter(event.dataItem);
        const newSelectedState = { ...selectedState };
        newSelectedState[selectedId] = !newSelectedState[selectedId];
        setSelectedState(newSelectedState);

        const newSelectedItems = filterdMediaData.filter((item) => newSelectedState[idGetter(item)]);
        setSelectedItems(newSelectedItems);
    };

    const onHeaderSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        const newSelectedState = {};
        if (checked) {
            filterdMediaData.forEach((item) => {
                newSelectedState[idGetter(item)] = true;
            });
            setSelectedItems([...filterdMediaData]);
        } else {
            setSelectedItems([]);
        }
        setSelectedState(newSelectedState);
    };

    const pageChange = (event) => {
        setPage(event.page);
        loadData({
            page: event.page.skip / event.page.take + 1,
            per_page: event.page.take,
            platform: filters.platform,
            agency: filters.agency,
            client: filters.client,
            campaignStatus: filters.campaignStatus,
            postStatus: filters.postStatus,
            searchText,
            fromDate: filters.fromDate ? new Date(filters.fromDate).getTime() : null,
            toDate: filters.toDate ? new Date(new Date(filters.toDate).setUTCHours(23, 59, 59, 999)).getTime() : null
        });
    };

    const refreshBrowser = (isSilent = false) => {
        applyFilters(searchText, filters, false, isSilent);
    };

    const onPublishCampaigns = async (items = []) => {
        const list = Array.isArray(items) ? items : [items];
        if (!list || list.length === 0) return;

        const ids = list.map(item => item.uniqueId);
        setActionLoading({ ids, action: "Publishing" });
        try {
            for (let item of list) {
                if (!item?.PublishPage?._id && !item?.PublishPage) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page_for_campaign_error_message });
                    continue;
                }
                const payload = {
                    pageId: item?.PublishPage?._id,
                    promotionPostId: item?.AttachedPost?.Post?._id,
                    platform: item?.PromotionsPlatform || item?.PromotionsPlatform?._id,
                    campaignId: item?._id
                };
                let res = await API.publishSocialMediaPromotionPosts(payload);
                if (res && res.success) {
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || lang.error_publish_campaign_error_message });
                }
            }
            refreshBrowser(true);
        } catch (err) {
            console.error("Error publishing campaign:", err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_publish_campaign_error_message });
        } finally {
            setActionLoading({ index: null, id: null, ids: [], action: "" });
        }
    };

    const onUnpublishCampaigns = async (items = []) => {
        const list = Array.isArray(items) ? items : [items];
        if (!list || list.length === 0) return;

        ConfirmAlert(
            async () => {
                const ids = list.map(item => item.uniqueId);
                setActionLoading({ ids, action: "Unpublishing" });
                try {
                    for (let item of list) {
                        const isPublished = item?.AttachedPost?.isPublished === true;
                        if (!isPublished) {
                            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_publish_post_first_error_message });
                            continue;
                        }
                        const postId = item?.AttachedPost?.postId || item?.postId;
                        if (!postId) {
                            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.post_id_not_found_for_unpublishing_error_message });
                            continue;
                        }
                        if (!item?.PublishPage?._id && !item?.PublishPage) {
                            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page_for_campaign_error_message });
                            continue;
                        }
                        const payload = {
                            pageId: item?.PublishPage?._id,
                            postId: postId,
                            platform: item?.PromotionsPlatform || item?.PromotionsPlatform?._id,
                            campaignId: item?._id,
                            promotionPostId: item?.AttachedPost?.Post?._id
                        };
                        let res = await API.unpublishSocialMediaPromotionPosts(payload);
                        if (res && res.success) {
                            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message || "Campaign unpublished successfully" });
                        } else {
                            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || "Error unpublishing campaign" });
                        }
                    }
                    refreshBrowser(true);
                } catch (err) {
                    console.error("Error unpublishing campaign:", err);
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_unpublishing_campaign_error_message });
                } finally {
                    setActionLoading({ index: null, id: null, ids: [], action: "" });
                }
            },
            () => { },
            lang.confirm_unpublish_message,
            lang.unpublish_for_confirm_message
        );
    };

    const onInsightCampaign = (dataItem) => {
        if (!dataItem) return;
        const isPublished = dataItem?.AttachedPost?.isPublished === true;
        if (!isPublished) {
            const historyList = dataItem?.AttachedPost?.history || [];
            const savedInsights = [...historyList].reverse().find(h => h.insights);
            if (savedInsights?.insights) {
                setShowInsightPopup({ show: true, item: dataItem, savedInsights: savedInsights.insights });
                return;
            }
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.invalid_error_message_title, message: lang.campaign_is_not_published_or_no_insight_avaiblable_info_message });
            return;
        }
        setShowInsightPopup({ show: true, item: dataItem });
    };

    const menuModel = [
        selectedItems.length > 0 && {
            label: lang.publish_label,
            icon: "pi pi-arrow-up",
            command: () => onPublishCampaigns(selectedItems)
        },
        selectedItems.length > 0 && {
            label: lang.unpublish_label,
            icon: "pi pi-arrow-down",
            command: () => onUnpublishCampaigns(selectedItems)
        },
        selectedItems.length === 1 && {
            label: lang.insight_label,
            icon: "pi pi-chart-bar",
            command: () => onInsightCampaign(selectedItems[0])
        }
    ].filter(Boolean);

    const getFilteredDropdownData = (data = [], fieldName) => {
        const filterValue = (dropdownFilters[fieldName] || '').toLowerCase();
        if (!filterValue) return data;
        return data.filter((item) => (item?.Name || item?.Description || '').toLowerCase().includes(filterValue));
    };

    const onDropdownFilterChange = (e, fieldName) => {
        setDropdownFilters((prev) => ({
            ...prev,
            [fieldName]: e.filter?.value || ''
        }));
    };
    const onCloseUserPrefence = () => {
        refreshBrowser(true);
        setShowPreferences(false);
    };

    const promotionScheduleMenuModel = (props) => {
        const isPublished = props?.dataItem?.AttachedPost?.isPublished === true;
        const items = [];

        if (isPublished) {
            items.push({ label: lang.insight_label, icon: 'pi pi-chart-bar', command: () => setShowInsightPopup({ show: true, item: props.dataItem }) });
        } else {
            const historyList = props?.dataItem?.AttachedPost?.history || [];
            const savedInsights = [...historyList].reverse().find(h => h.insights);
            const hasStoredInsights = Boolean(savedInsights?.insights && (Object.keys(savedInsights?.insights).length > 0));
            if (hasStoredInsights) {
                items.push({ label: lang.last_insight_label, icon: 'pi pi-chart-bar', command: () => setShowInsightPopup({ show: true, item: props.dataItem, savedInsights: savedInsights?.insights }) });
            }
        }

        items.push({
            label: lang.history_label,
            icon: 'pi pi-history',
            command: () => {
                const historyList = props?.dataItem?.AttachedPost?.history || [];
                if (!historyList || historyList.length === 0) {
                    ToastNotification({ type: TOAST_TYPES.INFO, title: lang.invalid_error_message_title, message: lang.publish_history_error_message });
                } else {
                    setShowHistoryPopup({ show: true, item: props?.dataItem });
                }
            }
        });

        items.push(
            { label: lang.publish_label, icon: 'pi pi-arrow-up', command: () => props.onPublish(props.dataItem) },
            { label: lang.un_publish_label, icon: 'pi pi-arrow-down', command: () => props.onUnPublish(props.dataItem) }
        );

        return [
            {
                label: lang.options_label,
                items: items
            }
        ];
    };

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            onPublish={onPublishCampaigns}
            onUnPublish={onUnpublishCampaigns}
            insight={onInsightCampaign}
            myMenuModel={promotionScheduleMenuModel}
        />
    );

    const CampaignStatusCell = (props) => {
        const { dataItem } = props;

        let title = utility.getKeyByValue(CAMPAIGN_STATUS, dataItem?.CampaignStatus);
        let tileBackColor = "";
        let titleColor = "white";

        switch (dataItem?.CampaignStatus) {
            case CAMPAIGN_STATUS.Active:
                title = title;
                tileBackColor = "#63AA43";
                break;
            case CAMPAIGN_STATUS.InActive:
                title = title;
                tileBackColor = "#E72929";
                break;
            case CAMPAIGN_STATUS.Upcoming:
                title = title;
                tileBackColor = "#e0590b";
                titleColor = "black";
                break;
        }
        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} titleColor={titleColor} />
        );
    };

    const PostPublishStatusCell = ({ dataItem, dataIndex }) => {
        const isRowLoading = actionLoading.index === dataIndex ||
            (actionLoading.id && (dataItem?._id === actionLoading.id || dataItem?.uniqueId === actionLoading.id || dataItem?.AttachedPost?._id === actionLoading.id || dataItem?.AttachedPost?.Post?._id === actionLoading.id)) ||
            (Array.isArray(actionLoading.ids) && actionLoading.ids.includes(dataItem?.uniqueId));
        if (isRowLoading) {
            return (
                <td>
                    <style>{waveStyles}</style>
                    <div
                        className="badge text-white px-2 py-2 fs-6 d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                            minWidth: '100px',
                            width: 'fit-content',
                            background: 'linear-gradient(270deg, #0d6efd, #00c6ff, #0072ff, #0d6efd)',
                            backgroundSize: '300% 300%',
                            animation: 'flowingGradientWave 2s ease infinite',
                            border: '1px solid rgba(255,255,255,0.3)'
                        }}
                    >
                        <span>{actionLoading.action}</span>
                        <div className="d-flex align-items-center" style={{ gap: '3px', marginLeft: '10px' }}>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0s' }}></span>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0.2s' }}></span>
                            <span style={{ display: 'inline-block', width: '4px', height: '4px', backgroundColor: '#fff', borderRadius: '50%', animation: 'waveBounce 1.2s infinite ease-in-out', animationDelay: '0.4s' }}></span>
                        </div>
                    </div>
                </td>
            );
        }

        const isPublished = dataItem?.AttachedPost?.isPublished === true;
        const status = isPublished ? lang.published_label : lang.unpublished_label;
        const statusClass = isPublished ? 'bg-success text-white' : 'bg-danger text-white';

        return (
            <td>
                <div className={`badge ${statusClass} px-3 py-2 fs-6`}>
                    {status}
                </div>
            </td>
        );
    };


    return (
        <div style={{ padding: '15px' }}>
            <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px', marginBottom: '15px' }}>
                <div className='d-flex'>
                    <div className='mr-auto d-flex'>
                        <h3 className='mr-1' style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                            {lang.sm_promotions_schedule_header}
                        </h3>
                        <p style={{ fontSize: '13px', color: '#666' }}>
                            ({total} {total === 1 ? 'item' : 'items'} found)
                        </p>
                    </div>
                </div>
                <div style={{ width: "100%" }}>
                    {/* Row 1: Actions & Search */}
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom: '15px', gap: '5px' }}>
                        <div>
                            <RefreshButton onClick={() => refreshBrowser(false)} />
                        </div>
                        <div>
                            <PreferenceRoundButton
                                icon={"gear"}
                                title={lang.preference_button_tooltip || "Preferences"}
                                onClick={() => setShowPreferences(!showPreferences)}
                            />
                        </div>
                        <div>
                            <RoundButton icon="ellipsis-v" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />
                            <ContextMenu ref={menuRef} model={menuModel} />
                        </div>
                        <div className='d-flex' style={{ marginLeft: "auto", width: "250px" }}>
                            <input
                                type="text"
                                className="form-control form-control-sm shadow-inset-2 pt-0 pb-0"
                                id="searchInput"
                                placeholder={lang.search_button_text}
                                value={searchText}
                                onChange={onSearch}
                            />
                            <button id="search" style={{ border: "0px", backgroundColor: "white" }}>
                                <span className="input-group-text" style={{ padding: "4px 10px", fontSize: "14px" }}>
                                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                </span>
                            </button>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap" }}>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(14% - 8px)', minWidth: '140px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.platform_label}</label>
                            <DropDownList
                                data={platforms}
                                dataItemKey="_id"
                                textField="Description"
                                value={filters.platform}
                                onChange={onChange}
                                name="platform"
                            />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(14% - 8px)', minWidth: '140px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.agency_label}</label>
                            <DropDownList
                                data={getFilteredDropdownData(agencies, 'agency')}
                                dataItemKey="_id"
                                textField="Name"
                                value={filters.agency}
                                onChange={onChange}
                                name="agency"
                                filterable={true}
                                onFilterChange={(e) => onDropdownFilterChange(e, 'agency')}
                            />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(14% - 8px)', minWidth: '140px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.client_label}</label>
                            <DropDownList
                                data={getFilteredDropdownData(clients, 'client')}
                                dataItemKey="_id"
                                textField="Name"
                                value={filters.client}
                                onChange={onChange}
                                name="client"
                                filterable={true}
                                onFilterChange={(e) => onDropdownFilterChange(e, 'client')}
                            />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(14% - 8px)', minWidth: '140px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.campaign_status_label}</label>
                            <DropDownList
                                data={campaignStatus}
                                dataItemKey="_id"
                                textField="Description"
                                value={filters.campaignStatus}
                                onChange={onChange}
                                name="campaignStatus"
                            />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(14% - 8px)', minWidth: '140px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.post_status_label}</label>
                            <DropDownList
                                data={postStatus}
                                dataItemKey="_id"
                                textField="Description"
                                value={filters.postStatus}
                                onChange={onChange}
                                name="postStatus"
                            />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(13% - 8px)', minWidth: '130px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.start_date_label}</label>
                            <input type="date" className="form-control form-control-sm" name="fromDate" value={filters.fromDate} onChange={onDateFilterChange} />
                        </div>
                        <div className='col-12 col-sm-6 p-2' style={{ minHeight: '75px', display: 'flex', flexDirection: 'column', flex: '1 1 calc(13% - 8px)', minWidth: '130px' }}>
                            <label style={{ marginBottom: '6px', fontWeight: '500' }}>{lang.end_Date_label}</label>
                            <input type="date" className="form-control form-control-sm" name="toDate" value={filters.toDate} onChange={onDateFilterChange} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Grid display */}
            <div className="media-list" style={{ display: 'grid' }}>
                {isLoading && <Loader />}
                {!isLoading && filterdMediaData.length === 0 && (
                    <p>{lang.no_records_found_message}</p>
                )}

                {!isLoading && filterdMediaData.length > 0 && (
                    <Grid
                        style={{ height: 'calc(100vh - 230px)', overflow: 'auto' }}
                        resizable={true}
                        sortable={{ allowUnsort: true, mode: 'multiple' }}
                        sort={sort}
                        onSortChange={(e) => setSort(e.sort)}
                        data={process(
                            filterdMediaData.map((data) => ({
                                ...data,
                                [SELECTED_FIELD]: !!selectedState[idGetter(data)]
                            })),
                            { sort }
                        )}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            mode: 'multiple',
                            type: 'cell',
                            checkboxOnly: true,
                            selectAllHeader: true
                        }}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        dataItemKey={DATA_ITEM_KEY}
                        pageable={true}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                    >
                        <GridColumn cell={MyCommandCell} width="60px" locked={true} resizable={false} />
                        <GridColumn field={SELECTED_FIELD} width="40px" />
                        {dataColumns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                                // }else if (column.name === COLUMNSTYPE.time) {
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                            } else if (column.name === "SID") {
                                return;
                                //we are not returning any value for SID column
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ImageCell}
                                        title={column.label}
                                        width={column.width ?? 100}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.toggle) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCustomToggleButton}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyHrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                        sortable={true}
                                    />
                                );
                            } else if (column.name === "CampaignStatus") {
                                return (
                                    <GridColumn
                                        field={column.name}
                                        title={column.label}
                                        cell={CampaignStatusCell}
                                        width={column.width ?? 130}
                                        sortable={false}
                                    />
                                )
                            } else if (column.name === "PostStatus") {
                                return (
                                    <GridColumn
                                        field={column.name}
                                        title={column.label}
                                        cell={PostPublishStatusCell}
                                        width={column.width ?? 130}
                                        sortable={false}
                                    />
                                )
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>
                )}
            </div>
            {showInsightPopup.show && (
                <MetaInsightsForm
                    item={showInsightPopup.item?.AttachedPost}
                    pageId={showInsightPopup.item?.PublishPage?._id || showInsightPopup.item?.PublishPage}
                    platform={showInsightPopup.item?.PromotionsPlatform?._id || showInsightPopup.item?.PromotionsPlatform}
                    savedInsights={showInsightPopup.savedInsights}
                    onClose={() => setShowInsightPopup({ show: false, item: null, savedInsights: null })}
                />
            )}
            {showHistoryPopup.show && (
                <PromotionPostHistoryPopup
                    item={showHistoryPopup.item?.AttachedPost}
                    onClose={() => setShowHistoryPopup({ show: false, item: null })}
                />
            )}
            {showPreferences && (<UserPreference entityName={"sm_promotion_schedule"} preferenceColumnENntityName={"sm_promotion_schedule"} handleClose={onCloseUserPrefence} />)}
        </div>
    );
};

export default SMPromotionScheduleCollection;
